/**
 * Post Media Render
 *
 * Shared rendering helpers for post media preview tiles and controls.
 */

import commonUtil from "../../util/common-utils";
import { Roles } from "../../constants/roles";

interface PreviewMediaItem {
    previewUrl?: string;
    name?: string;
}

class PostMediaRender {
    public static createImageElement(image: PreviewMediaItem, index: number): HTMLDivElement {
        const tile = document.createElement("div");
        tile.className = "picker-tile picker-tile-with-controls";
        tile.setAttribute("data-role", Roles.MEDIA_TILE);

        const src = commonUtil.escapeHtmlAttribute(image?.previewUrl || "");
        const alt = commonUtil.escapeHtmlAttribute(image?.name || "image");

        tile.innerHTML = `
            <img src="${src}" alt="${alt}">
            <div class="picker-controls" data-role="${Roles.MEDIA_CONTROLS}">
                <button
                    type="button"
                    class="btn circle-clear media-picker picker-remove"
                    data-role="${Roles.MEDIA_REMOVE}"
                    data-index="${index}"
                    aria-label="Remove image"
                ></button>
            </div>
        `;

        return tile;
    }

    public static createVideoElement(video: PreviewMediaItem, index: number): HTMLDivElement {
        const tile = document.createElement("div");
        tile.className = "picker-tile picker-tile-with-controls";
        tile.setAttribute("data-role", Roles.MEDIA_TILE);

        const src = commonUtil.escapeHtmlAttribute(video?.previewUrl || "");
        const alt = commonUtil.escapeHtmlAttribute(video?.name || `Video ${index + 1}`);
        const mediaContent = src
            ? `<img src="${src}" alt="${alt}">`
            : `<div class="picker-tile-no-preview"><i class="bi bi-camera-video"></i></div>`;

        tile.innerHTML = `
            ${mediaContent}
            <div class="picker-controls" data-role="${Roles.MEDIA_CONTROLS}">
                <button
                    type="button"
                    class="btn circle-clear media-picker picker-remove"
                    data-role="${Roles.MEDIA_REMOVE}"
                    data-index="${index}"
                    aria-label="Remove video"
                ></button>
            </div>
        `;

        return tile;
    }
}

export { PostMediaRender };
